goog.provide('el8.appanalytics.dialog.bulkLettersPatientList');

goog.require('el8.uiwidget.ReactDialog');

el8.appanalytics.dialog.bulkLettersPatientList = (function() {

    var that = new el8.uiwidget.ReactDialog({
        title: 'View List',
        autoHeight: true,
        id: 'bulk-letters-patient-list-dialog',
        reactComponentFn: function(id, props) {
            el8React.renderBulkLettersPatientListDialog(id, props);
        },
        width: 659,
        reactProps: {},
        showXButton: true
    });
    return that;
})();
